module.exports = __webpack_public_path__ + "img/刘志伟.e85bba58.jpg";